import XMLBuilder from 'fast-xml-builder';
import { XMLParser } from 'fast-xml-parser';

const parser = new XMLParser({
	ignoreAttributes: false,
	attributeNamePrefix: '$',
	ignoreDeclaration: true,
	parseAttributeValue: true,
	allowBooleanAttributes: true,
	removeNSPrefix: true,
});

const builder = new XMLBuilder({
	ignoreAttributes: false,
	attributeNamePrefix: '$',
	format: false,
	suppressEmptyNode: true,
});

export class XmlUtil {
	static obj2Xml(obj: unknown): string {
		return '<?xml version="1.0" standalone="yes"?>' + builder.build(obj);
	}

	static xml2Obj(xml: string): Record<string, unknown> {
		return parser.parse(xml) as Record<string, unknown>;
	}

	static rootElementName(xml: string): string {
		const keys = Object.keys(XmlUtil.xml2Obj(xml));
		return keys[0] ?? '';
	}
}
